module.exports = __webpack_public_path__ + "img/image_correction_buttons.1ded31de.png";